import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import type {
    DropCollectionListQuery,
    DropCollectionListResponse,
    DropCollectionResponse
} from '~/service/api/drop/types';
import fallbackApi from '~/service/api/fallbackApi';

export default (http: AxiosInstance) => ({
    async dropGet(slug: string) {
        const res = await http.get<DropCollectionResponse>(`/drop/info/${slug}`);
        return res.data;
    },
    async dropList(query?: DropCollectionListQuery) {
        const fallbackConfig = fallbackApi<DropCollectionListResponse>({
            text: 'Loading drops',
            description: 'An error occurred while loading drops',
            visible: 'error',
            exclude: [
                404,
                403
            ],
            fallback: {
                data: [],
                pagination: {
                    page: 0,
                    size: 0,
                    total: 0
                },
                status: {
                    code: 404,
                    message: 'Response fallbackApi',
                    msgId: '1'
                }
            }
        });

        const config: AxiosRequestConfig = {
            params: {
                ...query
                    ? { ...query }
                    : {}
            },
            ...fallbackConfig
        };

        const res = await http.get<DropCollectionListResponse>(
            '/drops/list',
            config
        );
        return res.data;
    }
} as const);
